import cn from "classnames";
import React from "react";
import { TypeOptions } from "react-toastify";
import { SuccessIcon } from "src/assets/icons";
import classes from "./Toast.module.scss";

interface Props {
  message: string;
  type: TypeOptions;
}
const ToastBody: React.FC<Props> = ({ message, type }) => {
  const getToastTitle = () => {
    switch (type) {
      case "success":
        return "Success!";
      default:
        return "Error";
    }
  };
  const getToastIcon = () => {
    switch (type) {
      default:
        return <SuccessIcon />;
    }
  };

  return (
    <div className={classes.toastWrapper}>
      <div
        className={cn(classes.iconWrapper, {
          [classes.success]: type === "success",
        })}
      >
        {getToastIcon()}
      </div>
      <div className={classes.messageBody}>
        <div className={classes.title}>{getToastTitle()}</div>
        <div className={classes.message}>{message}</div>
      </div>
    </div>
  );
};

export default ToastBody;
